import { Inject, Injectable, Injector } from '@angular/core';

import { Document360_FlowService } from './Document360.flow.index';
import { Usersnap_FlowService } from './Usersnap.flow.index';
import { Utilities_FlowService } from './Utilities.flow.index';
import { Addresses_FlowService } from './Addresses.flow.index';
import { BarcodeParsing_FlowService } from './BarcodeParsing.flow.index';
import { BarTender_FlowService } from './BarTender.flow.index';
import { Catalogs_FlowService } from './Catalogs.flow.index';
import { Discussions_FlowService } from './Discussions.flow.index';
import { DockAppointments_FlowService } from './DockAppointments.flow.index';
import { EntityImport_FlowService } from './EntityImport.flow.index';
import { Equipment_FlowService } from './Equipment.flow.index';
import { ExcelInventoryImport_FlowService } from './ExcelInventoryImport.flow.index';
import { ExcelLocationImport_FlowService } from './ExcelLocationImport.flow.index';
import { ExcelMaterialImport_FlowService } from './ExcelMaterialImport.flow.index';
import { ExcelProjectImport_FlowService } from './ExcelProjectImport.flow.index';
import { Inspections_FlowService } from './Inspections.flow.index';
import { InventoryTransfers_FlowService } from './InventoryTransfers.flow.index';
import { LaborManagement_FlowService } from './LaborManagement.flow.index';
import { LoadContainers_FlowService } from './LoadContainers.flow.index';
import { Owners_FlowService } from './Owners.flow.index';
import { PalletTransactions_FlowService } from './PalletTransactions.flow.index';
import { PrimaryPicks_FlowService } from './PrimaryPicks.flow.index';
import { Replenishments_FlowService } from './Replenishments.flow.index';
import { Returns_FlowService } from './Returns.flow.index';
import { Surveys_FlowService } from './Surveys.flow.index';
import { TemperatureReadings_FlowService } from './TemperatureReadings.flow.index';
import { TransloadOrders_FlowService } from './TransloadOrders.flow.index';
import { WarehouseTransfers_FlowService } from './WarehouseTransfers.flow.index';
import { Waves_FlowService } from './Waves.flow.index';
import { Instructions_FlowService } from './Instructions.flow.index';
import { WorkOrders_FlowService } from './WorkOrders.flow.index';
import { InventoryCounts_FlowService } from './InventoryCounts.flow.index';
import { ShippingContainers_FlowService } from './ShippingContainers.flow.index';
import { Materials_FlowService } from './Materials.flow.index';
import { Carriers_FlowService } from './Carriers.flow.index';
import { Locations_FlowService } from './Locations.flow.index';
import { PurchaseOrders_FlowService } from './PurchaseOrders.flow.index';
import { Allocations_FlowService } from './Allocations.flow.index';
import { PrintNode_FlowService } from './PrintNode.flow.index';
import { SerialNumbers_FlowService } from './SerialNumbers.flow.index';
import { Lots_FlowService } from './Lots.flow.index';
import { Inventory_FlowService } from './Inventory.flow.index';
import { AsnOrders_FlowService } from './AsnOrders.flow.index';
import { ExcelOrderImport_FlowService } from './ExcelOrderImport.flow.index';
import { Attachments_FlowService } from './Attachments.flow.index';
import { Cartonization_FlowService } from './Cartonization.flow.index';
import { Invoices_FlowService } from './Invoices.flow.index';
import { Notifications_FlowService } from './Notifications.flow.index';
import { InventoryTransformations_FlowService } from './InventoryTransformations.flow.index';
import { Manifesting_FlowService } from './Manifesting.flow.index';
import { PackVerification_FlowService } from './PackVerification.flow.index';
import { SalesOrders_FlowService } from './SalesOrders.flow.index';
import { Manufacturing_FlowService } from './Manufacturing.flow.index';

import { FootprintManager_activate_deactivate_planService } from './FootprintManager.flow.index';
import { FootprintManager_convert_order_to_ediService } from './FootprintManager.flow.index';
import { FootprintManager_create_manufacturing_order_copiesService } from './FootprintManager.flow.index';
import { FootprintManager_create_update_planService } from './FootprintManager.flow.index';
import { FootprintManager_delete_planService } from './FootprintManager.flow.index';
import { FootprintManager_get_integration_info_by_order_idService } from './FootprintManager.flow.index';
import { FootprintManager_get_inventory_count_status_flow_altService } from './FootprintManager.flow.index';
import { FootprintManager_get_planService } from './FootprintManager.flow.index';
import { FootprintManager_is_edi_order_flowService } from './FootprintManager.flow.index';
import { FootprintManager_main_auto_email_execute_rules_flowService } from './FootprintManager.flow.index';
import { FootprintManager_print_pack_verification_reportsService } from './FootprintManager.flow.index';
import { FootprintManager_reason_codes_create_update_delete_flowService } from './FootprintManager.flow.index';

import { $frontendTypes } from './FootprintManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintManager_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Document360 = this.injector.get(Document360_FlowService);
    this.Usersnap = this.injector.get(Usersnap_FlowService);
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.Addresses = this.injector.get(Addresses_FlowService);
    this.BarcodeParsing = this.injector.get(BarcodeParsing_FlowService);
    this.BarTender = this.injector.get(BarTender_FlowService);
    this.Catalogs = this.injector.get(Catalogs_FlowService);
    this.Discussions = this.injector.get(Discussions_FlowService);
    this.DockAppointments = this.injector.get(DockAppointments_FlowService);
    this.EntityImport = this.injector.get(EntityImport_FlowService);
    this.Equipment = this.injector.get(Equipment_FlowService);
    this.ExcelInventoryImport = this.injector.get(ExcelInventoryImport_FlowService);
    this.ExcelLocationImport = this.injector.get(ExcelLocationImport_FlowService);
    this.ExcelMaterialImport = this.injector.get(ExcelMaterialImport_FlowService);
    this.ExcelProjectImport = this.injector.get(ExcelProjectImport_FlowService);
    this.Inspections = this.injector.get(Inspections_FlowService);
    this.InventoryTransfers = this.injector.get(InventoryTransfers_FlowService);
    this.LaborManagement = this.injector.get(LaborManagement_FlowService);
    this.LoadContainers = this.injector.get(LoadContainers_FlowService);
    this.Owners = this.injector.get(Owners_FlowService);
    this.PalletTransactions = this.injector.get(PalletTransactions_FlowService);
    this.PrimaryPicks = this.injector.get(PrimaryPicks_FlowService);
    this.Replenishments = this.injector.get(Replenishments_FlowService);
    this.Returns = this.injector.get(Returns_FlowService);
    this.Surveys = this.injector.get(Surveys_FlowService);
    this.TemperatureReadings = this.injector.get(TemperatureReadings_FlowService);
    this.TransloadOrders = this.injector.get(TransloadOrders_FlowService);
    this.WarehouseTransfers = this.injector.get(WarehouseTransfers_FlowService);
    this.Waves = this.injector.get(Waves_FlowService);
    this.Instructions = this.injector.get(Instructions_FlowService);
    this.WorkOrders = this.injector.get(WorkOrders_FlowService);
    this.InventoryCounts = this.injector.get(InventoryCounts_FlowService);
    this.ShippingContainers = this.injector.get(ShippingContainers_FlowService);
    this.Materials = this.injector.get(Materials_FlowService);
    this.Carriers = this.injector.get(Carriers_FlowService);
    this.Locations = this.injector.get(Locations_FlowService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_FlowService);
    this.Allocations = this.injector.get(Allocations_FlowService);
    this.PrintNode = this.injector.get(PrintNode_FlowService);
    this.SerialNumbers = this.injector.get(SerialNumbers_FlowService);
    this.Lots = this.injector.get(Lots_FlowService);
    this.Inventory = this.injector.get(Inventory_FlowService);
    this.AsnOrders = this.injector.get(AsnOrders_FlowService);
    this.ExcelOrderImport = this.injector.get(ExcelOrderImport_FlowService);
    this.Attachments = this.injector.get(Attachments_FlowService);
    this.Cartonization = this.injector.get(Cartonization_FlowService);
    this.Invoices = this.injector.get(Invoices_FlowService);
    this.Notifications = this.injector.get(Notifications_FlowService);
    this.InventoryTransformations = this.injector.get(InventoryTransformations_FlowService);
    this.Manifesting = this.injector.get(Manifesting_FlowService);
    this.PackVerification = this.injector.get(PackVerification_FlowService);
    this.SalesOrders = this.injector.get(SalesOrders_FlowService);
    this.Manufacturing = this.injector.get(Manufacturing_FlowService);
  }

    public Document360: Document360_FlowService;
    public Usersnap: Usersnap_FlowService;
    public Utilities: Utilities_FlowService;
    public Addresses: Addresses_FlowService;
    public BarcodeParsing: BarcodeParsing_FlowService;
    public BarTender: BarTender_FlowService;
    public Catalogs: Catalogs_FlowService;
    public Discussions: Discussions_FlowService;
    public DockAppointments: DockAppointments_FlowService;
    public EntityImport: EntityImport_FlowService;
    public Equipment: Equipment_FlowService;
    public ExcelInventoryImport: ExcelInventoryImport_FlowService;
    public ExcelLocationImport: ExcelLocationImport_FlowService;
    public ExcelMaterialImport: ExcelMaterialImport_FlowService;
    public ExcelProjectImport: ExcelProjectImport_FlowService;
    public Inspections: Inspections_FlowService;
    public InventoryTransfers: InventoryTransfers_FlowService;
    public LaborManagement: LaborManagement_FlowService;
    public LoadContainers: LoadContainers_FlowService;
    public Owners: Owners_FlowService;
    public PalletTransactions: PalletTransactions_FlowService;
    public PrimaryPicks: PrimaryPicks_FlowService;
    public Replenishments: Replenishments_FlowService;
    public Returns: Returns_FlowService;
    public Surveys: Surveys_FlowService;
    public TemperatureReadings: TemperatureReadings_FlowService;
    public TransloadOrders: TransloadOrders_FlowService;
    public WarehouseTransfers: WarehouseTransfers_FlowService;
    public Waves: Waves_FlowService;
    public Instructions: Instructions_FlowService;
    public WorkOrders: WorkOrders_FlowService;
    public InventoryCounts: InventoryCounts_FlowService;
    public ShippingContainers: ShippingContainers_FlowService;
    public Materials: Materials_FlowService;
    public Carriers: Carriers_FlowService;
    public Locations: Locations_FlowService;
    public PurchaseOrders: PurchaseOrders_FlowService;
    public Allocations: Allocations_FlowService;
    public PrintNode: PrintNode_FlowService;
    public SerialNumbers: SerialNumbers_FlowService;
    public Lots: Lots_FlowService;
    public Inventory: Inventory_FlowService;
    public AsnOrders: AsnOrders_FlowService;
    public ExcelOrderImport: ExcelOrderImport_FlowService;
    public Attachments: Attachments_FlowService;
    public Cartonization: Cartonization_FlowService;
    public Invoices: Invoices_FlowService;
    public Notifications: Notifications_FlowService;
    public InventoryTransformations: InventoryTransformations_FlowService;
    public Manifesting: Manifesting_FlowService;
    public PackVerification: PackVerification_FlowService;
    public SalesOrders: SalesOrders_FlowService;
    public Manufacturing: Manufacturing_FlowService;
  public FootprintManager: FootprintManager_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _activate_deactivate_plan: FootprintManager_activate_deactivate_planService;
  public async activate_deactivate_plan(inParams: { plan_id: string, is_active: boolean }): Promise<void> {
    if(!this._activate_deactivate_plan) { 
      this._activate_deactivate_plan = this.injector.get(FootprintManager_activate_deactivate_planService);
    }
    return this._activate_deactivate_plan.run(inParams);
  }
   
   

   
 
  private _convert_order_to_edi: FootprintManager_convert_order_to_ediService;
  public async convert_order_to_edi(inParams: { order_id: number }): Promise<void> {
    if(!this._convert_order_to_edi) { 
      this._convert_order_to_edi = this.injector.get(FootprintManager_convert_order_to_ediService);
    }
    return this._convert_order_to_edi.run(inParams);
  }
   
   

   
 
  private _create_manufacturing_order_copies: FootprintManager_create_manufacturing_order_copiesService;
  public async create_manufacturing_order_copies(inParams: { name?: string, template_order_id?: number, pre_requirements?: any, copies_params?: { offset_in_days?: number, total_runs?: number }, schedule?: { date_option?: string, date_interval?: any, time_option?: string, time_interval?: any, time_offset?: number, time_zone?: { country?: string, utc?: string, time_zone?: string } } }): Promise< { order_ids: number[], reasons: string[] }> {
    if(!this._create_manufacturing_order_copies) { 
      this._create_manufacturing_order_copies = this.injector.get(FootprintManager_create_manufacturing_order_copiesService);
    }
    return this._create_manufacturing_order_copies.run(inParams);
  }
   
   

   
 
  private _create_update_plan: FootprintManager_create_update_planService;
  public async create_update_plan(inParams: { plan_id?: string, in_params: $frontendTypes.Manufacturing.CreateOrderCopiesParams, cron_expression: string, is_active: boolean }): Promise< { reasons?: string[], plan_id?: string }> {
    if(!this._create_update_plan) { 
      this._create_update_plan = this.injector.get(FootprintManager_create_update_planService);
    }
    return this._create_update_plan.run(inParams);
  }
   
   

   
 
  private _delete_plan: FootprintManager_delete_planService;
  public async delete_plan(inParams: { plan_id: string }): Promise<void> {
    if(!this._delete_plan) { 
      this._delete_plan = this.injector.get(FootprintManager_delete_planService);
    }
    return this._delete_plan.run(inParams);
  }
   
   

   
 
  private _get_integration_info_by_order_id: FootprintManager_get_integration_info_by_order_idService;
  public async get_integration_info_by_order_id(inParams: { order_id?: number }): Promise< { Source?: string, IntegrationHubId?: string, IntegrationHubSourceId?: string, IntegrationHubSourceLookupCode?: string, IntegrationHubSourcePlatform?: string, WavelengthConnectorTransmissions?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Direction?: string, IntegrationId?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, TransactionId?: string, Type?: string, Entity?: string }[] }> {
    if(!this._get_integration_info_by_order_id) { 
      this._get_integration_info_by_order_id = this.injector.get(FootprintManager_get_integration_info_by_order_idService);
    }
    return this._get_integration_info_by_order_id.run(inParams);
  }
   
   

   
 
  private _get_inventory_count_status_flow_alt: FootprintManager_get_inventory_count_status_flow_altService;
  public async get_inventory_count_status_flow_alt(inParams: { inventoryCountIds: number[], optimalInputs?: { inventoryCountId?: number, tasks?: { operationCodeId?: number, statusId?: number }[], statusId?: number, statusName?: string }[] }): Promise< { inventoryCounts?: { id?: number, actualStatusId?: number, actualStatusName?: string, descriptiveStatusName?: string, actionValidations?: { failReleaseReasons?: string[], failHoldReasons?: string[], failDuplicateReasons?: string[], failCompleteReasons?: string[], failCancelReasons?: string[], failDeleteReasons?: string[], allowEdit?: boolean } }[], errors?: string[] }> {
    if(!this._get_inventory_count_status_flow_alt) { 
      this._get_inventory_count_status_flow_alt = this.injector.get(FootprintManager_get_inventory_count_status_flow_altService);
    }
    return this._get_inventory_count_status_flow_alt.run(inParams);
  }
   
   

   
 
  private _get_plan: FootprintManager_get_planService;
  public async get_plan(inParams: { plan_id?: string }): Promise< { name?: string, plan_id?: string, is_active?: boolean, in_params?: $frontendTypes.Manufacturing.CreateOrderCopiesParams, cron_expression?: string }> {
    if(!this._get_plan) { 
      this._get_plan = this.injector.get(FootprintManager_get_planService);
    }
    return this._get_plan.run(inParams);
  }
   
   

   
 
  private _is_edi_order_flow: FootprintManager_is_edi_order_flowService;
  public async is_edi_order_flow(inParams: { order_id: number }): Promise< { result?: boolean }> {
    if(!this._is_edi_order_flow) { 
      this._is_edi_order_flow = this.injector.get(FootprintManager_is_edi_order_flowService);
    }
    return this._is_edi_order_flow.run(inParams);
  }
   
   

   
 
  private _main_auto_email_execute_rules_flow: FootprintManager_main_auto_email_execute_rules_flowService;
  public async main_auto_email_execute_rules_flow(inParams: {  }): Promise< { logs?: string[] }> {
    if(!this._main_auto_email_execute_rules_flow) { 
      this._main_auto_email_execute_rules_flow = this.injector.get(FootprintManager_main_auto_email_execute_rules_flowService);
    }
    return this._main_auto_email_execute_rules_flow.run(inParams);
  }
   
   

   
 
  private _print_pack_verification_reports: FootprintManager_print_pack_verification_reportsService;
  public async print_pack_verification_reports(inParams: { shipping_container_id: number, location_id: number }): Promise< { reasons?: string[] }> {
    if(!this._print_pack_verification_reports) { 
      this._print_pack_verification_reports = this.injector.get(FootprintManager_print_pack_verification_reportsService);
    }
    return this._print_pack_verification_reports.run(inParams);
  }
   
   

   
 
  private _reason_codes_create_update_delete_flow: FootprintManager_reason_codes_create_update_delete_flowService;
  public async reason_codes_create_update_delete_flow(inParams: { payload?: any, action: string, id?: number }): Promise< { success?: boolean, message?: string, id?: number }> {
    if(!this._reason_codes_create_update_delete_flow) { 
      this._reason_codes_create_update_delete_flow = this.injector.get(FootprintManager_reason_codes_create_update_delete_flowService);
    }
    return this._reason_codes_create_update_delete_flow.run(inParams);
  }
   
   

   
}
